import { UserRole } from '@lmc/ts-common'
import { Button, Icon } from '@lmc/ui-kit'
import { useRoleAccess } from 'components/AccessControl'
import { commonPatterns } from '../../../../utils/enhancedTestIds'

interface DownloadLogsCSVButtonProps {
  openModal: () => void
  disabled: boolean
  exporting: boolean
  testId?: string
}

const DownloadLogsCSVButton = ({
  openModal,
  disabled,
  exporting,
  testId
}: DownloadLogsCSVButtonProps) => {
  const hasRolePermission = useRoleAccess(
    [UserRole.careHomeAdmin],
    [
      {
        i: 'download',
        this: 'Report'
      }
    ]
  )

  const downloadTestId = testId
    ? commonPatterns.button(testId, 'download-csv')
    : undefined

  return (
    <Button
      onClick={openModal}
      disabled={disabled}
      disabledByPermission={!hasRolePermission}
      variant="default"
      icon={<Icon name="CloudDownloadOutlined" />}
      data-testid={downloadTestId}
    >
      {exporting ? 'Downloading...' : 'Export CSV'}
    </Button>
  )
}

export default DownloadLogsCSVButton
